import { render, staticRenderFns } from "./gSide.vue?vue&type=template&id=22f905a4&scoped=true&"
import script from "./gSide.vue?vue&type=script&lang=js&"
export * from "./gSide.vue?vue&type=script&lang=js&"
import style0 from "./gSide.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gSide.vue?vue&type=style&index=1&id=22f905a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f905a4",
  null
  
)

export default component.exports